
import { HomeUser } from "./user";
import { HomeProfessional } from "./professional";
import { CanAccess } from "@refinedev/core";
import { GoogleServicesTemplate } from "@components/templates/googleServices";
import { PRO_ROLES, USER_ROLES } from "access/definitions";

export const Home = () => {
    return <GoogleServicesTemplate navbar={<></>}>
        <CanAccess resource="home" action="show" params={{ roles: PRO_ROLES }}>
            <HomeProfessional />
        </CanAccess>
        <CanAccess resource="home" action="show" params={{ roles: USER_ROLES }}>
            <HomeUser />
        </CanAccess>
    </GoogleServicesTemplate>
}
